import axios from "../axios-auth";
import orginal_axios from "axios";

export const saleTeamService = {
  getSaleTeamList,
  saveSaleTeam,
  getSaleTeamDetail,
  getSaleTeamsByStatus,
  getSaleTeamExcelTemplate,
  saveSaleTeamExcel,
  getSaleTeamExcelExport,
};

function getSaleTeamList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.isAddDetail) {
    params["isAddDetail"] = searchParams.isAddDetail;
  }

  return axios.get("/auth/sale-teams", { params });
}

function saveSaleTeam(saleTeam) {
  if (!saleTeam.id) {
    // new saleTeam
    return axios.post("/auth/sale-team", saleTeam);
  } else {
    // edit
    return axios.put("/auth/sale-team", saleTeam);
  }
}

function getSaleTeamDetail(id) {
  return axios.get("/auth/sale-team/" + id);
}

function getSaleTeamsByStatus(status) {
  return axios.get("/auth/sale-teams-by-status/" + status);
}

function getSaleTeamExcelExport(searchParams) {
  let params = {};

  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.isAddDetail) {
    params["isAddDetail"] = searchParams.isAddDetail;
  }

  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/sale-team-excel-export",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function getSaleTeamExcelTemplate() {
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/sale-team-excel-template",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function saveSaleTeamExcel(file) {
  return axios.post('/auth/sale-team-excel',
    file,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}
